import PublicLayout from 'components/layout/PublicLayout'
import getBrandFromDomain from 'helpers/getBrandFromDomain'
import useContent from 'hooks/useContent'
import styled from 'styled-components'
import bpLogo from 'assets/logos/bp-logo-colour.svg'
import aralLogo from 'assets/logos/aral-logo.svg'
import { Logo, LogoWrapper } from 'src/pages/Authentication/LoginPage/LoginPage.styled'
import { BRAND_ARAL } from 'src/constants/brands'

const Content = styled.div`
  padding: 16px 0;
  text-align: left;

  > span:first-child {
    font-weight: bold;
  }
`
const Text = styled.p`
  width: 100%;
  text-align: center;
  margin-bottom: 2em;
  font-size: 1.2em;
  color: black;
`

const ErrorDisplay = () => {
  const brand = getBrandFromDomain();
  const content = useContent('login')
 return (
    <PublicLayout>
      <LogoWrapper>
        <Logo src={brand === BRAND_ARAL ? aralLogo : bpLogo} />
      </LogoWrapper>
      <Content>
        {<Text>{content?.Login_errorMessage}</Text>}
      </Content>
    </PublicLayout>
 )
}

export default ErrorDisplay